module.exports = __webpack_public_path__ + "img/1578776381.2c1cf942.jpg";